export default "__VITE_ASSET__DkD75xr5__"